import React from "react";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
    Button,
    Link,
} from "@cloudscape-design/components";
import {
    setPageTitle,
} from "src/core/redux";
import { SentinelPageProps } from "src/web/interfaces";
import { SentinelBasePage } from "src/web/pages/sentinel-base";
import { useNavigate } from "react-router-dom";
import "../../styles/app.css";
import dsLogo from "src/assets/DS.png";
export interface SentinelOverviewPageProps extends SentinelPageProps { }
export const LandingPage: React.FC<SentinelOverviewPageProps> = (
    // eslint-disable-next-line
    props: SentinelOverviewPageProps
) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setPageTitle("Overview"));
    }, []);
    return (
        <SentinelBasePage>
            <div style={{ textAlign: "center" }}>
                <img
                    src={dsLogo}
                    style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
                    alt="Dependency Sentinel"
                />
            </div>
            <p>
                <span className="bolded">Dependency Sentinel</span> is a platform that will
                automatically generate code reviews for trivially updatable dependencies.
            </p>
            <div>
                <p>The platform supports:</p>
                <ul>
                    <li> Scans pipelines to fetch packages, version set and branch information</li>
                    <li> Scan the software packages and gather a list of dependencies (library, runtime, and test dependencies only)</li>
                    <li>
                        Periodically scan for new releases and updated guidance, apply the guidance and produce code reviews where applicable (currently minor version bumps only)
                    </li>
                    <li> Perform a basic test of the service by running unit tests</li>
                    <li> Submit a code review that team can review and merge</li>
                </ul>
            </div>
            <p>
                For more information about Dependency Sentinel, visit the{" "}
                <Link
                    href="https://w.amazon.com/bin/view/DependencySentinel"
                    external={true}
                >
                    wiki
                </Link>
                .
            </p>
            <Button
                variant="primary"
                onClick={() => navigate("onboard")}
            >
                Onboard Now
            </Button>
        </SentinelBasePage>
    );
};
export default LandingPage;
